import { useState } from 'react';
import './FAQ.scss';
import {useTranslation} from "react-i18next";



const faqItems: number[] = [0,1,2,3,4,5];

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState<number | null>(0);
    const { t } = useTranslation();

    const toggleItem = (index: number) => {
        setOpenIndex((current) => (current === index ? null : index));
    };

    return (
        <section className="faq-section" id="faq">
            <div className="faq-container">
                <div className="faq-heading">

                    <h2 className="faq-title">
                        {t(`FAQ.title.normal`)} <span>{t(`FAQ.title.bold`)}</span>
                    </h2>

                    <p className="faq-subtitle">
                        {t(`FAQ.subtitle`)}
                    </p>
                </div>

                <div className="faq-list">
                    {faqItems.map((item) => {
                        const isOpen = openIndex === item;

                        return (
                            <div
                                className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}
                                key={item}
                            >
                                <button
                                    type="button"
                                    className="faq-question"
                                    onClick={() => toggleItem(item)}
                                    aria-expanded={isOpen}
                                    aria-controls={`faq-answer-${item}`}
                                >
                  <span className="faq-question__text">
                    {t(`FAQ.questions.${item}.question`)}
                  </span>

                                    <span
                                        className="faq-question__icon"
                                        aria-hidden="true"
                                    >
                    <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M6 9L12 15L18 9"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                                </button>

                                <div
                                    id={`faq-answer-${item}`}
                                    className="faq-answer"
                                    aria-hidden={!isOpen}
                                >
                                    <div className="faq-answer__inner">
                                        <p>{t(`FAQ.questions.${item}.answer`)}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
